import { useCurrentUser } from '@qualio/ui-components';
import { useQuery } from 'react-query';
import { userApi } from '../api/user';

export const useUsers = () => {
  const { companyId } = useCurrentUser();
  return useQuery({
    queryFn: async () => {
      const users = await userApi.fetchUsers(companyId);
      return users ?? [];
    },
    queryKey: ['userList'],
    refetchOnWindowFocus: false,
  });
};
